import {RcFile} from 'antd/es/upload/interface';

export function checkIsFile(file: string | Blob | RcFile): file is RcFile {
    return file instanceof File && 'uid' in file;
}
